<template>
  <!-- begin::Page loader -->
  <div id="loader" style="height: 100vh; display: none" class="d-flex justify-content-center align-items-center">
    <GeneralLoading></GeneralLoading>
  </div>
  <!-- end::Page Loader -->
</template>

<script>
import GeneralLoading from "@/assets/components/loader/GeneralLoading";
export default {
  name: "Loader",
  components: {
    GeneralLoading
  }
};
</script>
